import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import api from '../../services/api';
import { LayoutDashboard, Users, Target, FileText, Wrench, Map, LogOut, Menu, X, Zap, File, Calendar, Columns, PlusCircle, DollarSign, UserCog, Eye, UserPlus, BarChart2, ScrollText, FolderOpen, MessageSquare, Package, BarChart, BookOpen, TrendingUp, Calculator, KeyRound, Activity, History } from 'lucide-react';

const S = {
  wrap: { display:'flex', minHeight:'100vh', background:'#080c14' },
  sidebar: (open) => ({ width: open?240:0, minWidth: open?240:0, background:'#0e1420', borderRight:'1px solid #1a2035', display:'flex', flexDirection:'column', transition:'all 0.25s', overflow:'hidden', flexShrink:0 }),
  logo: { padding:'24px 20px 16px', borderBottom:'1px solid #1a2035', display:'flex', alignItems:'center', gap:10 },
  logoIcon: { color:'#f6c90e', display:'flex' },
  logoText: { fontFamily:'serif', fontSize:18, fontWeight:700, color:'#f6c90e', letterSpacing:1 },
  logoSub: { fontSize:10, color:'#475569', letterSpacing:2, textTransform:'uppercase', marginTop:1 },
  nav: { flex:1, padding:'12px 10px', display:'flex', flexDirection:'column', gap:2, overflowY:'auto' },
  link: (active) => ({ display:'flex', alignItems:'center', gap:10, padding:'9px 12px', borderRadius:8, cursor:'pointer', fontSize:13, fontWeight:500, textDecoration:'none', color: active?'#f6c90e':'#64748b', background: active?'rgba(246,201,14,0.08)':'transparent', border: active?'1px solid rgba(246,201,14,0.15)':'1px solid transparent', transition:'all 0.15s', whiteSpace:'nowrap' }),
  section: { fontSize:9, color:'#2d3748', textTransform:'uppercase', letterSpacing:2, padding:'10px 12px 4px', fontWeight:700 },
  userBox: { padding:'12px 16px', borderTop:'1px solid #1a2035', display:'flex', alignItems:'center', gap:10 },
  avatar: { width:32, height:32, borderRadius:'50%', background:'linear-gradient(135deg,#f6c90e,#e8a800)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:13, fontWeight:700, color:'#080c14', flexShrink:0 },
  main: { flex:1, display:'flex', flexDirection:'column', overflow:'hidden' },
  topbar: { height:52, background:'#0e1420', borderBottom:'1px solid #1a2035', display:'flex', alignItems:'center', padding:'0 20px', gap:12 },
  menuBtn: { background:'none', border:'1px solid #1a2035', borderRadius:6, cursor:'pointer', color:'#64748b', padding:'5px 7px', display:'flex', alignItems:'center' },
  content: { flex:1, overflow:'auto', padding:24 },
};

function NavItem({ to, icon: Icon, label, onNavigate }) {
  return (
    <NavLink to={to} style={({ isActive }) => S.link(isActive)} onClick={onNavigate}>
      <Icon size={16} /><span>{label}</span>
    </NavLink>
  );
}

function ModalSenha({ onClose }) {
  const [senhaAtual, setSenhaAtual] = useState('');
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmar, setConfirmar] = useState('');
  const [erro, setErro] = useState('');
  const [sucesso, setSucesso] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    if (novaSenha !== confirmar) { setErro('As senhas novas não coincidem.'); return; }
    if (novaSenha.length < 6) { setErro('A nova senha deve ter pelo menos 6 caracteres.'); return; }
    setLoading(true);
    try {
      await api.post('/auth/change-password/', { senha_atual: senhaAtual, nova_senha: novaSenha });
      setSucesso(true);
      setTimeout(onClose, 1800);
    } catch (err) {
      setErro(err.response?.data?.error || 'Erro ao alterar senha.');
    } finally {
      setLoading(false);
    }
  };

  const overlay = { position:'fixed', inset:0, background:'rgba(0,0,0,0.6)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:9999 };
  const box = { background:'#0e1420', border:'1px solid #1a2035', borderRadius:12, padding:28, width:340, display:'flex', flexDirection:'column', gap:16 };
  const inp = { background:'#080c14', border:'1px solid #1a2035', borderRadius:8, padding:'9px 12px', color:'#e2e8f0', fontSize:13, outline:'none', width:'100%' };
  const btn = (primary) => ({ padding:'9px 18px', borderRadius:8, border:'none', cursor:'pointer', fontSize:13, fontWeight:600, background: primary ? '#f6c90e' : 'transparent', color: primary ? '#080c14' : '#64748b' });

  return (
    <div style={overlay} onClick={e => e.target===e.currentTarget && onClose()}>
      <div style={box}>
        <div style={{ display:'flex', alignItems:'center', gap:8, color:'#f6c90e' }}>
          <KeyRound size={18} />
          <span style={{ fontSize:15, fontWeight:700, color:'#e2e8f0' }}>Alterar Senha</span>
        </div>
        {sucesso ? (
          <div style={{ color:'#22c55e', fontSize:13, textAlign:'center', padding:'12px 0' }}>Senha alterada com sucesso!</div>
        ) : (
          <form onSubmit={handleSubmit} style={{ display:'flex', flexDirection:'column', gap:12 }}>
            <div>
              <label style={{ fontSize:11, color:'#64748b', display:'block', marginBottom:4 }}>Senha atual</label>
              <input type="password" style={inp} value={senhaAtual} onChange={e => setSenhaAtual(e.target.value)} required autoFocus />
            </div>
            <div>
              <label style={{ fontSize:11, color:'#64748b', display:'block', marginBottom:4 }}>Nova senha</label>
              <input type="password" style={inp} value={novaSenha} onChange={e => setNovaSenha(e.target.value)} required />
            </div>
            <div>
              <label style={{ fontSize:11, color:'#64748b', display:'block', marginBottom:4 }}>Confirmar nova senha</label>
              <input type="password" style={inp} value={confirmar} onChange={e => setConfirmar(e.target.value)} required />
            </div>
            {erro && <div style={{ color:'#ef4444', fontSize:12 }}>{erro}</div>}
            <div style={{ display:'flex', justifyContent:'flex-end', gap:8, marginTop:4 }}>
              <button type="button" style={btn(false)} onClick={onClose}>Cancelar</button>
              <button type="submit" style={btn(true)} disabled={loading}>{loading ? 'Salvando...' : 'Salvar'}</button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default function Layout() {
  const { user, logout, isChefe, isVendedor, isGerenteComercial, isPreVenda, isPosVenda, isEngenheiro, isInstalador } = useAuth();
  const [open, setOpen] = useState(true);
  const [modalSenha, setModalSenha] = useState(false);
  const navigate = useNavigate();

  const handleLogout = async () => { await logout(); };
  const initials = user?.nome?.split(' ').map(n => n[0]).join('').slice(0,2).toUpperCase() || '?';

  const handleNavClick = () => {
    setOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
    // scroll do conteúdo principal também
    const content = document.getElementById('main-content');
    if (content) content.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div style={S.wrap}>
      <aside style={S.sidebar(open)}>
        <div style={S.logo}>
          <span style={S.logoIcon}><Zap size={22} /></span>
          <div>
            <div style={S.logoText}>E-Solar</div>
            <div style={S.logoSub}>Sistema de Gestão</div>
          </div>
        </div>

        <nav style={S.nav}>
          {/* Dashboard — chefe, gerente e vendedor */}
          {(isChefe() || isVendedor() || isGerenteComercial()) && <NavItem to="/" icon={LayoutDashboard} label="Dashboard" onNavigate={handleNavClick} />}

          {/* Gerente Comercial — privilégios equivalentes ao chefe (exceto financeiro/custos) */}
          {isGerenteComercial() && <>
            <div style={S.section}>Geral</div>
            <NavItem to="/geral" icon={Eye} label="Visão Geral" onNavigate={handleNavClick} />
            <NavItem to="/mapa" icon={Map} label="Mapa de Projetos" onNavigate={handleNavClick} />

            {user?.id && <>
              <div style={S.section}>Meu Perfil</div>
              <NavItem to={`/vendedor/${user.id}/performance`} icon={BarChart2} label="Meu Desempenho" onNavigate={handleNavClick} />
            </>}

            <div style={S.section}>Operacional</div>
            <NavItem to="/agenda" icon={Calendar} label="Agenda" onNavigate={handleNavClick} />
            <NavItem to="/controle" icon={Columns} label="Controle" onNavigate={handleNavClick} />
            <NavItem to="/clientes" icon={Users} label="Clientes" onNavigate={handleNavClick} />
            <NavItem to="/cadastrar-cliente" icon={UserPlus} label="Cadastrar Cliente" onNavigate={handleNavClick} />
            <NavItem to="/kits" icon={Package} label="Kits" onNavigate={handleNavClick} />
            <NavItem to="/simulador-parcelas" icon={Calculator} label="Simulador de Parcelas" onNavigate={handleNavClick} />

            <div style={S.section}>Documentos</div>
            <NavItem to="/documentos" icon={FolderOpen} label="Documentos" onNavigate={handleNavClick} />

            <div style={S.section}>Gestão</div>
            <NavItem to="/projetos" icon={Wrench} label="Projetos" onNavigate={handleNavClick} />
            <NavItem to="/nota-vendedor" icon={ScrollText} label="Nota Vendedor" onNavigate={handleNavClick} />
          </>}

          {/* Geral — oculto para Instalador, Engenheiro, Gerente Comercial e Vendedor */}
          {!isInstalador() && !isEngenheiro() && !isGerenteComercial() && <>
            <div style={S.section}>Geral</div>
            {!isVendedor() && <NavItem to="/geral" icon={Eye} label="Visão Geral" onNavigate={handleNavClick} />}
            {!isPreVenda() && !isPosVenda() && <NavItem to="/mapa" icon={Map} label="Mapa de Projetos" onNavigate={handleNavClick} />}
          </>}

          {/* Pré Venda — apenas pré-venda, chefe não vê */}
          {isPreVenda() && <>
            <div style={S.section}>Pré Venda</div>
            <NavItem to="/pre-venda"        icon={PlusCircle}   label="Cadastrar Lead" onNavigate={handleNavClick} />
            <NavItem to="/pre-venda-leads"  icon={Users}        label="Meus Leads" onNavigate={handleNavClick} />
            <NavItem to="/pre-venda-kanban" icon={Columns}      label="Kanban" onNavigate={handleNavClick} />
            <NavItem to="/pre-venda-atualizacoes" icon={History} label="Últimas Atualizações" onNavigate={handleNavClick} />
            <NavItem to="/nota-vendedor"    icon={MessageSquare} label="Nota Vendedor" onNavigate={handleNavClick} />
          </>}

          {/* Instalador — somente Agenda + Clientes + Kits */}
          {isInstalador() && <>
            <div style={S.section}>Operacional</div>
            <NavItem to="/agenda" icon={Calendar} label="Agenda" onNavigate={handleNavClick} />
            <NavItem to="/clientes" icon={Users} label="Clientes" onNavigate={handleNavClick} />
            <NavItem to="/kits" icon={Package} label="Kits" onNavigate={handleNavClick} />
          </>}

          {/* Desempenho — vendedor e chefe veem o próprio */}
          {(isVendedor() || isChefe()) && user?.id && <>
            <div style={S.section}>Meu Perfil</div>
            <NavItem to={`/vendedor/${user.id}/performance`} icon={BarChart2} label="Meu Desempenho" onNavigate={handleNavClick} />
          </>}

          {/* Vendedor / Engenheiro / Pós Venda */}
          {(isChefe() || isVendedor() || isPosVenda() || isEngenheiro()) && <>
            <div style={S.section}>Operacional</div>
            <NavItem to="/agenda" icon={Calendar} label="Agenda" onNavigate={handleNavClick} />
            <NavItem to="/controle" icon={Columns} label="Controle" onNavigate={handleNavClick} />
            <NavItem to="/clientes" icon={Users} label="Clientes" onNavigate={handleNavClick} />
            {isVendedor() && <NavItem to="/cadastrar-cliente" icon={UserPlus} label="Cadastrar Cliente" onNavigate={handleNavClick} />}
            <NavItem to="/kits" icon={Package} label="Kits" onNavigate={handleNavClick} />
            {(isChefe() || isVendedor()) && <NavItem to="/simulador-parcelas" icon={Calculator} label="Simulador de Parcelas" onNavigate={handleNavClick} />}
            {isVendedor() && <NavItem to="/nota-vendedor" icon={MessageSquare} label="Nota Vendedor" onNavigate={handleNavClick} />}
          </>}

          {/* Documentos unificado */}
          {(isChefe() || isVendedor() || isEngenheiro() || isPosVenda()) && <>
            <div style={S.section}>Documentos</div>
            <NavItem to="/documentos" icon={FolderOpen} label="Documentos" onNavigate={handleNavClick} />
          </>}

          {/* Chefe */}
          {isChefe() && <>
            <div style={S.section}>Gestão</div>
            <NavItem to="/cadastrar-cliente" icon={UserPlus} label="Cadastrar Cliente" onNavigate={handleNavClick} />
            <NavItem to="/projetos" icon={Wrench} label="Projetos" onNavigate={handleNavClick} />
            <NavItem to="/funcionarios" icon={UserCog} label="Funcionários" onNavigate={handleNavClick} />
            <NavItem to="/nota-engenheiro" icon={MessageSquare} label="Nota Engenheiro" onNavigate={handleNavClick} />
            <NavItem to="/nota-vendedor" icon={ScrollText} label="Nota Vendedor" onNavigate={handleNavClick} />
            <NavItem to="/kits" icon={Package} label="Kits" onNavigate={handleNavClick} />
            <NavItem to="/simulador-parcelas" icon={Calculator} label="Simulador de Parcelas" onNavigate={handleNavClick} />

            <NavItem to="/monitoramento" icon={Activity} label="Monitoramento" onNavigate={handleNavClick} />

            <div style={S.section}>Financeiro</div>
            <NavItem to="/financeiro" icon={DollarSign} label="Financeiro Comercial" onNavigate={handleNavClick} />
            <NavItem to="/custos-comercial" icon={BarChart} label="Custos Comercial" onNavigate={handleNavClick} />
            <NavItem to="/custos-da-empresa" icon={BookOpen} label="Custos da Empresa" onNavigate={handleNavClick} />
            <NavItem to="/resumo-financeiro" icon={TrendingUp} label="Resumo Financeiro" onNavigate={handleNavClick} />
          </>}
        </nav>

        <div style={S.userBox}>
          <div style={S.avatar}>{initials}</div>
          <div
            style={{ cursor: isChefe() ? 'default' : 'pointer', flex:1 }}
            onClick={() => !isChefe() && setModalSenha(true)}
            title={isChefe() ? '' : 'Clique para alterar a senha'}
          >
            <div style={{ fontSize:12, fontWeight:600, color:'#cbd5e1', whiteSpace:'nowrap', display:'flex', alignItems:'center', gap:4 }}>
              {user?.nome}
              {!isChefe() && <KeyRound size={11} color="#475569" />}
            </div>
            <div style={{ fontSize:10, color:'#475569', whiteSpace:'nowrap' }}>{user?.cargo}</div>
          </div>
          <button style={{ marginLeft:'auto', background:'none', border:'none', cursor:'pointer', color:'#475569', padding:4, borderRadius:4, display:'flex' }} onClick={handleLogout} title="Sair">
            <LogOut size={15} />
          </button>
        </div>
      </aside>

      <main style={S.main}>
        <div style={S.topbar}>
          <button style={S.menuBtn} onClick={() => setOpen(o => !o)}>
            {open ? <X size={16} /> : <Menu size={16} />}
          </button>
          <span style={{ color:'#475569', fontSize:12 }}>
            {new Date().toLocaleDateString('pt-BR', { weekday:'long', day:'numeric', month:'long', year:'numeric' })}
          </span>
        </div>
        <div id="main-content" style={S.content}><Outlet /></div>
      </main>

      {modalSenha && <ModalSenha onClose={() => setModalSenha(false)} />}
    </div>
  );
}
